<template>
    <div>
        <el-dialog
                :before-close="onCancel"
                :close-on-click-modal="false"
                :title="title"
                :visible.sync="dialogVisible"
                @open="open"
                width="80%"
                class="big-dialog"
        >
            <div class="content-search">
                <el-input v-model="queryParams.searchName"
                          placeholder="请输入索引、证件号、扫码号、姓名"
                          clearable
                          @clear="onSearch">
                    <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
                </el-input>
            </div>
            <div class="content-table" v-if="tableData.length>0">
                <el-table :data="tableData">
                    <template v-for="(item,index) in sortArr">
                        <el-table-column :prop="item" :label="item" align="center">
                            <template slot-scope="scope">
                                <template v-if="item==='证件照片' || item==='实时照片' || item==='登记照片'">
                                    <el-image class="table-image" v-if="scope.row[item]" :src="scope.row[item]"
                                              :preview-src-list="[scope.row[item]]">
                                        <div slot="placeholder" class="image-slot">
                                            <i class="el-icon-loading img-loading"></i>
                                        </div>
                                    </el-image>
                                </template>
                                <template v-else>
                                    <span class="ytg_color" v-if="scope.row[item]==='通过'">通过</span>
                                    <span class="wtg_color" v-else-if="scope.row[item]==='未通过'">未通过</span>
                                    <span class="wsb_color" v-else-if="scope.row[item]==='未识别'">未识别</span>
                                    <span v-else>{{scope.row[item]}}</span>
                                </template>
                            </template>
                        </el-table-column>
                    </template>
                    <el-table-column label="操作" align="center" min-width="90px" fixed="right">
                        <template slot-scope="scope">
                            <el-button
                                    size="small"
                                    type="text"
                                    class="btn_3"
                                    @click="onView(scope.row)"
                            >查看详情
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-empty v-else class="content-empty" description="暂无数据"></el-empty>
        </el-dialog>
        <!--查看查看详情弹框-->
        <view-info
                :idFu="idFu"
                :dialogVisibleFu="dialogVisibleSVFu"
                @closeDialog="closeSVDialog"
        />
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {GetStudentInfo} from "../request/record";
    import ViewInfo from "./ViewInfo";

    export default {
        name: "ShowTableMonitor",
        components: {ViewInfo},
        props: {
            titleFu: String,
            statusFu: [String, Number],
            jsonKeyFu: Object,
            dialogVisibleFu: Boolean,
        },
        data() {
            return {
                loading: false,
                queryParams: {
                    searchName: '',
                },
                dialogVisible: this.dialogVisibleFu,
                status: this.statusFu,
                title: this.titleFu,
                tableData: [],
                sortArr: [],// 表格表头数组
                idFu: null,
                dialogVisibleSVFu: false, // 控制查看详情弹框显示与隐藏
            };
        },
        methods: {
            // 关闭查看详情弹框
            closeSVDialog(val) {
                this.dialogVisibleSVFu = val;
            },
            // 查看详情按钮
            onView(row) {
                this.idFu = row['学生编号'];
                this.dialogVisibleSVFu = true;
            },
            onSearch() {
                this.getList();
            },
            open() {
                this.getList();
            },
            getList() {
                if (this.loading) {
                    return false;
                }
                this.loading = true;
                GetStudentInfo({
                    projectId: this.getUserInfo.projectId,
                    eventCount: this.getSession,
                    uuid: this.getLink,
                    jsonKey: this.jsonKeyFu,
                    status: this.status,
                    ...this.queryParams,
                })
                    .then((res) => {
                        // console.log(res)
                        if (res.code != 200) {
                            this.loading = false;
                            return this.$message.error(res.message);
                        }
                        this.tableData = res.data.list;
                        this.sortArr = res.data.sortList;
                        this.loading = false;
                    })
                    .catch((err) => {
                        // console.log(err);
                        this.loading = false;
                    });
            },
            onCancel() {
                this.queryParams = {
                    searchName: '',
                }
                this.sortArr = [];
                this.tableData = [];
                this.dialogVisible = false;
                this.$emit("closeDialog", this.dialogVisible);
            },
        },
        computed: {
            ...mapGetters([
                'getUserInfo',
                'getSession',
                'getLink',
            ])
        },
        watch: {
            dialogVisibleFu() {
                this.dialogVisible = this.dialogVisibleFu;
            },
            statusFu() {
                this.status = this.statusFu;
            },
            titleFu() {
                this.title = this.titleFu;
            },
        },
    };
</script>

<style scoped lang="scss">
    @import "../assets/scss/common";
</style>
